import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { fadeInSlideAnimation } from 'animations';
import { TranslationProvider } from 'providers/translation/translation';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { RemoteServicesProvider } from 'providers/remote-services/remote-services';
import { LoginProvider } from 'providers/login/login';
import { SpotData } from 'dto/spotdata';
import { v4 as uuid } from "uuid";
import { LocalstorageProvider } from 'providers/localstorage/localstorage';

declare var window:any;

@Component({
    selector: 'app-newspot',
    templateUrl: './newspot.component.html',
    styleUrls: ['./newspot.component.scss'],

    animations: [fadeInSlideAnimation],
    host: { '[@fadeInSlideAnimation]': '' }
})
export class NewSpotComponent implements OnInit {

    showConfirmation: boolean = false;
    showSurveyBlock = this.domainStorageProvider.rootStore.survey.length > 0;
    showProductsBlock = this.domainStorageProvider.rootStore.products.length > 0;
    spotData: SpotData = null;
    isLoading: boolean = false;
    selectedGroup = null;

    constructor(
        private router: Router,
        private appService: AppService,
        public translationProvider: TranslationProvider,
        private domainStorageProvider: DomainStorageProvider,
        private remoteServicesProvider: RemoteServicesProvider,
        private localStorageProvider: LocalstorageProvider,
        private loginProvider: LoginProvider
    ) {
        this.showHideMenu(false);
        this.selectedGroup = this.domainStorageProvider.rootStore.getSelectedGroup();

        let spotData = this.domainStorageProvider.rootStore.spotData.value;
        if (spotData) {
            this.spotData = spotData;
        }
        else {
            this.router.navigate(["/searchpos"]);
        }
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    confirm() {
        this.showConfirmation = true;
    }

    hide() {
        this.showConfirmation = false;
    }

    close() {
        this.router.navigate(["/"]);
    }

    back() {
        this.confirm();
    }

    onStartCheck() {
        this.submitSpot();
    }

    openNewSpotImages() {
        this.router.navigate(['/newspot/images']);
    }

    openNewSpotSurvey() {
        this.router.navigate(['/newspot/survey']);
    }

    openNewSpotProducts() {
        this.router.navigate(['/newspot/products']);
    }

    async submitSpot() {

        var contentId = this.appService.url2contentId("/submit_report");
        window.wts.push(['send', 'click', { linkId: contentId, customClickParameter: { 1: 'button', 2: 'footer' } }]);

        this.isLoading = true;

        let spotList = this.spotData.generateOutput();
        let statusCode: string = null;
        let sendSpotProcess = await this.remoteServicesProvider
            .sendSpot(spotList, this.loginProvider.token)
            .catch(err => {
                statusCode = err.status;
            });
        this.isLoading = false;

        if (sendSpotProcess) {
            this.router.navigate(['/newspot/success']);
        }
        else {
            //save the spot data to be able to sync it later
            this.localStorageProvider.write("spot-" + uuid(), spotList);
            this.router.navigate(['/newspot/error/', statusCode]);
        }
    }
}
